import { observable, action } from 'mobx'

export type ITheme = 'light' | 'dark'

class ThemeStore {
  @observable theme: ITheme = 'light'

  @action
  apply(theme: ITheme) {
    this.theme = theme
  }

  @action
  hydrate(theme: ITheme) {
    this.apply(theme)
  }
}

export default new ThemeStore()
